// extracted by mini-css-extract-plugin
export default {"container":"AccodionComponent_container__xiZFu","title":"AccodionComponent_title__FB4Tr","accodian":"AccodionComponent_accodian__uaUiS"};